
import React, { createContext } from "react";
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../routes'
import { useKeycloak } from '@react-keycloak/web'
import EntityServices from "../Services/Consumers/EntityServices";

const LateSubmissionViewContext = createContext({})

const LateSubmissionViewProvider = ({ id, locale, children }) => {

    const intl = useIntl()
    let history = useHistory()
    const { keycloak } = useKeycloak()

    const [lateSubmissionData, setLateSubmissionData] = React.useState({})
    const [isUnauthorized, setIsUnauthorized] = React.useState(false)
    const [lateSubmissioneDataLoading, setLateSubmissionDataLoading] = React.useState(false)

    React.useEffect(() => {
        if (!!id) {
            getlateSubmissionData()
        } else {
            history.push({
                pathname: NamedRoutes.lateSubmission
            })
        }

    }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [])

    const getlateSubmissionData = () => {
        if (!!keycloak?.authenticated && !!id) {
            setLateSubmissionDataLoading(true)
            EntityServices.getLateSubmissionData({ 'id': id }, intl.formatMessage({ id: 'single.remainingQuota.Error' })).then((result) => {
                if (!!result?.response && result?.response?.status === 403) {
                    setIsUnauthorized(true)
                } else if (!!result && !!result.data) {
                    setLateSubmissionData(result.data)
                }
                setLateSubmissionDataLoading(false)
            })
        }
    }

    return (
        <LateSubmissionViewContext.Provider value={{
            id,
            lateSubmissionData,
            isUnauthorized,
            lateSubmissioneDataLoading
        }}>
            {children}
        </LateSubmissionViewContext.Provider>
    )
}

const LateSubmissionViewConsumer = LateSubmissionViewContext.Consumer

export { LateSubmissionViewContext, LateSubmissionViewConsumer, LateSubmissionViewProvider }